import { forwardRef } from 'react';

import * as S from './style';

interface InputTextProps {
	placeholder?: string;
	input?: (e: React.ChangeEvent<HTMLInputElement>) => void;
	readonly?: boolean;
	value?: string;
	isError?: boolean;
	type?: string;
	maxLength?: number;
	onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
	onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
}

const InputText = forwardRef<HTMLInputElement, InputTextProps>(
	({ placeholder, input, readonly, value, isError, maxLength, type = 'text', onBlur, onKeyDown, ...props }, ref) => (
		<S.Container>
			<S.ContainerInput
				ref={ref}
				type={type}
				placeholder={placeholder}
				onChange={input}
				readOnly={readonly}
				value={value}
				onBlur={onBlur}
				onKeyDown={onKeyDown}
				isError={isError}
				maxLength={maxLength}
				{...props}
			/>
			{isError && (
				<S.IconWrapper>
					<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							d="M8 0.5C3.92857 0.5 0.5 3.92857 0.5 8C0.5 12.0714 3.92857 15.5 8 15.5C12.0714 15.5 15.5 12.1786 15.5 8C15.5 3.82143 12.1786 0.5 8 0.5Z"
							fill="#DC2626"
						/>
						<path d="M8 4.25V9.125" stroke="white" strokeLinecap="round" />
						<path
							d="M8.59998 11.7109C8.59998 12.0216 8.34814 12.2734 8.03748 12.2734C7.72682 12.2734 7.47498 12.0216 7.47498 11.7109C7.47498 11.4003 7.72682 11.1484 8.03748 11.1484C8.34814 11.1484 8.59998 11.4003 8.59998 11.7109Z"
							fill="white"
						/>
					</svg>
				</S.IconWrapper>
			)}
		</S.Container>
	)
);

// 디스플레이 네임 추가
InputText.displayName = 'InputText';

export default InputText;
